import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			RefillError: null,
			loading: false
		}
	}
	checkRefils = (e) => {
		fetch(window.location.origin + window.location.pathname + 'Refills', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status === 200) {
				console.log("Refills valid")
				var response = await response.json();
				this.props.data.ExpirationDate = response.date
				this.props.data.QuantityEntered = response.quantity
				this.props.data.QuantityRequested = response.quantity
				this.props.data.QuantityApproved = response.quantity
				this.props.data.RefillsApproved = response.RefillsApproved
				if (this.props.data.ModeOfAdmin == "T") {
					console.log("Mode of Admin is T")
					this.setState({ loading: true })
					fetch(window.location.origin + window.location.pathname + 'R26Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
						this.setState({ loading: false })
						if (response.status == 200) {
							var PANumber = await response.text();
							if (PANumber) {
								this.props.setData('PANumber', PANumber)
								this.props.navigate("R28")
							} else {
								this.props.navigate("R26c")

							}
						} else {
							this.props.navigate("R26B")
						}
					})
				} else {
					this.props.navigate('R17')
				}
			} else {
				this.setState({ RefillError: await response.text() })
			}
		})





		// var valid = false
		// if (this.props.data.ModeOfAdmin == "T" || this.props.data.InbornMetabolic) {
		// 	//Max is 5
		// 	if (parseInt(this.props.data.RefillsRequested) > 5) {
		// 		this.setState({ RefillError: 'Invalid response.' })
		// 	} else {
		// 		valid = true;
		// 	}
		// } else {
		// 	//Age Check
		// 	if (new Date().getTime() - new Date(this.props.data.DOB).getTime() < (31536000000 * 21)) {
		// 		//under 21
		// 		if (parseInt(this.props.data.RefillsRequested) > 5) {
		// 			this.setState({ RefillError: 'Invalid response.' })
		// 		} else {
		// 			valid = true;
		// 		}
		// 	} else {
		// 		//over 21
		// 		if (parseInt(this.props.data.RefillsRequested) > 2) {
		// 			this.setState({ RefillError: 'That is not a valid response. For patients 21 years of age or older, you may prescribe a maximum of two refills.' })
		// 		} else {
		// 			valid = true;

		// 		}
		// 	}

		// }
		// if (valid) {
		// 	var date = new Date(); // Now
		// 	date = date.setDate(date.getDate() + ((parseInt(this.props.data.RefillsRequested) + 1) * 30)); // Set now + 30 days as the new date
		// 	console.log(date);
		// 	var quantity = (parseInt(this.props.data.CaloricUnits) * (parseInt(this.props.data.RefillsRequested) + 1))
		// 	console.log(quantity);
		// 	this.props.data.ExpirationDate = date
		// 	this.props.data.QuantityEntered = quantity
		// 	this.props.data.QuantityRequested = quantity
		// 	this.props.data.QuantityApproved = quantity
		// 	this.props.data.RefillsApproved = this.props.data.RefillsRequested
		// 	console.log(this.props.data.QuantityEntered)
		// 	console.log(this.props.data)


		// 	if (this.props.data.ModeOfAdmin == "T") {
		// 		this.setState({ loading: true })
		// 		fetch(window.location.origin + window.location.pathname + 'R26Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
		// 			this.setState({ loading: false })
		// 			if (response.status == 200) {
		// 				var PANumber = await response.text();
		// 				if (PANumber) {
		// 					this.props.setData('PANumber', PANumber)
		// 					this.props.navigate("R28")
		// 				} else {
		// 					this.props.navigate("R26c")

		// 				}
		// 			} else {
		// 				this.props.navigate("R26B")
		// 			}
		// 		})
		// 	} else {
		// 		this.props.navigate('R17')
		// 	}
		// }


	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Enter the total number of refills being prescribed:</p>
				<input type="number" value={this.props.data.RefillsRequested} onChange={(e) => { this.props.setData('RefillsRequested', e.currentTarget.value > 5 ? 5 : e.currentTarget.value < 0 ? 0 : e.currentTarget.value) }} />
				{this.state.RefillError ? <div className="error">{this.state.RefillError}</div> : ''}
				{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={() => { this.checkRefils() }}>Continue</div>}
			</div>
		);
	}
}